import type {ReactElement} from 'react';
import {ClickableDiv} from '@Components/clickable-div';
import type {SavedAccountRowProps} from './saved-account-row.types';
import {SavedAccountIdentity} from '../saved-account-identity/saved-account-identity';
import {InitialsAvatarSize} from '../initials-avatar/initials-avatar.types';
import styles from './saved-account-row.module.scss';
import {AuthTestId} from '@/test-ids/auth-test-id';

/** One remembered account in the chooser; the whole row is the target. */
export function SavedAccountRow({account, onChoose}: SavedAccountRowProps): ReactElement {
  const chooseAccount = (): void => {
    onChoose(account);
  };

  return (
    <ClickableDiv className={styles.row} data-testid={AuthTestId.SAVED_ACCOUNT_ROW} onClick={chooseAccount}>
      <SavedAccountIdentity account={account} avatarSize={InitialsAvatarSize.SMALL} />
    </ClickableDiv>
  );
}
